import React, { useEffect} from "react";
import { Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeRewardDashboard } from "../../../../../redux/employeereward/employeeRewardState";
import { Coins, Star, TrendingUp, Users } from "lucide-react";



const OverviewSummaryCard = ({ }) => {
  const dispatch = useDispatch();

  const dashboardStats = useSelector((state) => state.employeeReward.dashboardStats?.data);

  useEffect(() => {
    dispatch(getEmployeeRewardDashboard());
  }, [dispatch]);

  const overviewStatus =
  [  
    {
      title: "Company Balance",
      icon: Coins,
      count: dashboardStats?.company_balance || 0,
      info: "Available credits",
      color: "emerald-white",
    },
    {
      title: "This Month",
      icon: TrendingUp,
      count: dashboardStats?.credits_awarded_month || 0,
      info: "Credits awarded",
      color: "purple-white",
    },
    {
      title: "Active Team",
      icon: Users,
      count: dashboardStats?.team_members_rewarded_month || 0,
      info: "Members awarded",
      color: "blue-white",
    },
    {
      title: "Avg. per Person",
      icon: Star,
      count: dashboardStats?.average_awards || 0,
      info: "Credits awarded",
      color: "amber-white",
    },

  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {overviewStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
            key={item.id}
            className={`rounded-xl card-border-s ${item.color}`}
          >
            <div className="flex items-center justify-between"> 
              <div>
                <p className="text-[12px] title-text mb-1">{item.title}</p>
                <p className="text-[24px] font-semibold card-text">{item.count.toLocaleString()}</p>
                <p className="text-xs muted-text">{item.info}</p>
              </div>
              <div className="icon-theme p-3 rounded-xl">
                <Icon className="w-8 h-8" />
              </div>
            </div>
        </Card>   
        );
      })}
    </div>
  );
};

export default OverviewSummaryCard;
